// 单字段排序 由于样式不支持多个排序，暂时先单个字段的排序
export function getSortSql (parameter, sortMap) {
  const field = parameter.sortField
  const order = parameter.sortOrder

  if (field) {
    let target = sortMap.find(item => item.sortField === field)
    if (target && order && order !== '') {
      if (order === 'descend') {
        target.sortOrder = 'desc'
      } else if (order === 'ascend') {
        target.sortOrder = 'asc'
      }

      return target.sortFieldOrig + '@' + target.sortOrder
    }
  }

  return ''
}

// 多字段排序 由于样式不支持多个排序，暂时先不启动多个字段的排序
export function getSortSqlMore (parameter, sortMap) {
  const field = parameter.sortField
  const order = parameter.sortOrder

  if (field) {
    let target = sortMap.find(item => item.sortField === field)
    if (target) {
      if (order === 'descend') {
        target.sortOrder = 'desc'
      } else if (order === 'ascend') {
        target.sortOrder = 'asc'
      } else {
        target.sortOrder = ''
      }
    }
  }

  let sortSqlMap = []
  sortMap.forEach(item => {
    if (item.sortOrder && item.sortOrder !== '') {
      sortSqlMap.push(item.sortFieldOrig + '@' + item.sortOrder)
    }
  })

  return sortSqlMap.join(',')
}
